export default __webpack_public_path__ + "static/Gotham-Book-8763ab87bed50f8421f53fe0b659115c.woff2";